import { useEffect, useState } from "react";
import NavMenu from "./components/Nav";
import servicosProduto from "../servicos/servicos-produto";
import servicosImagens from "../servicos/servicos-imagens";
import { Link } from "react-router-dom";
import NavMobile from "./components/NavMobile";
import { basePath } from "../utils/baseUrl";
import Spinner from "./components/Spinner";

const Produtos = () => {
    const [produtos, setProdutos] = useState([]);
    const [imagens, setImagens] = useState([]);
    const [imagensProdutos, setImagensProdutos] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setIsLoading(true);
        servicosProduto
            .listarTodosCategoria1()
            .then((response) => {
                let aux = [];
                if (response.status === 200) {
                    for (const produto of imagens) {
                        let contem = false;
                        for (const iterator of response.data) {
                            if (String(produto.Produto[0].nome).trim() === String(iterator.nome).trim()) {
                                contem = true;
                            }
                        }
                        if (contem === true) {
                            if (aux.length < 26) {
                                aux.push(produto);
                            }
                        }
                    }
                    setProdutos(aux);
                    setTimeout(() => {
                        setIsLoading(false);
                    }, 1000);
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }, [imagens]);

    useEffect(() => {
        setIsLoading(true);
        servicosImagens
            .listarTodas()
            .then((response) => {
                if (response.status === 200) {
                    setImagens(response.data);
                    setTimeout(() => {
                        setIsLoading(false);
                    }, 1000);
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }, []);

    useEffect(() => {
        setIsLoading(true);
        let aux = [];
        for (const produto of produtos) {
            for (const iterator of imagens) {
                if (produto.id_produto === iterator.id_produto) {
                    aux.push(iterator);
                }
            }
        }
        const filteredArray = aux.filter(
            (obj, index, self) =>
                index ===
                self.findIndex((o) => o.Produto[0].nome === obj.Produto[0].nome)
        );
        setImagensProdutos(filteredArray);
        setTimeout(() => {
            setIsLoading(false);
        }, 1000);
    }, [produtos, imagens]);






    return <>
        <NavMenu />
        {isLoading ? <div className="container mt-5 d-flex justify-content-center align-items-center"><Spinner mensagem="Carregando lista de produtos" /></div> : <div className="container">
            <div className="d-flex flex-wrap align-content-around justify-content-center">
                {imagensProdutos.map(item => {
                    return (
                        <Link key={item.id_produto} to={"/CardProduto"} state={{ produto: item }} style={{ height: 450 }} >
                            <div className="card d-flex justify-content-center align-items-center m-3 border-0" style={{ width: '20rem' }}>
                                <img className="border-1 border-bottom card-img-top" src={`${basePath}/${item.filename}`} style={{ height: 250, width: '100%' }} alt="..." />
                                <div className="card-body text-center" style={{ width: '100%', height: 150 }}>
                                    <h5 className="card-title subtitulo" style={{ fontSize: 22 }}>$ {item.Produto[0].milhas}</h5>
                                    <h5 className="card-title subtitulo " style={{ fontSize: 22, textAlign: "center" }}> {item.Produto[0].nome}</h5>
                                </div>
                            </div>
                        </Link>
                    )
                })}
            </div>

        </div>}
        <NavMobile />

    </>
}

export default Produtos;